import { lazy } from 'react';

import { ROLE_NAME } from 'enums';
import { PATHS } from 'types';

const Confirmation = lazy(() =>
  import('views/pages/auth/Confirmation/Confirmation').then(module => ({
    default: module.Confirmation,
  })),
);
const ConfirmationExpired = lazy(() =>
  import('views/pages/auth/ConfirmationExpired/ConfirmationExpired').then(module => ({
    default: module.ConfirmationExpired,
  })),
);
const ConfirmationResult = lazy(() =>
  import('views/pages/auth/ConfirmationResult/ConfirmationResult').then(module => ({
    default: module.ConfirmationResult,
  })),
);
const ForgotPassword = lazy(() =>
  import('views/pages/auth/ForgotPassword/ForgotPassword').then(module => ({
    default: module.ForgotPassword,
  })),
);
const ForgotPasswordSent = lazy(() =>
  import('views/pages/auth/ForgotPassword/ForgotPasswordSent/ForgotPasswordSent').then(
    module => ({ default: module.ForgotPasswordSent }),
  ),
);
const Login = lazy(() =>
  import('views/pages/auth/Login/Login').then(module => ({ default: module.Login })),
);
const Registration = lazy(() =>
  import('views/pages/auth/Registration/Registration').then(module => ({
    default: module.Registration,
  })),
);
const ResetPasswordChanged = lazy(() =>
  import('views/pages/auth/ResetPassword/ResetPasswordChanged/ResetPasswordChanged').then(
    module => ({ default: module.ResetPasswordChanged }),
  ),
);
const CompanyMembers = lazy(() =>
  import('views/pages/CompanyMembers/CompanyMembers').then(module => ({
    default: module.CompanyMembers,
  })),
);
const ActivityDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/ActivityDrilldown').then(module => ({
    default: module.ActivityDrilldown,
  })),
);
const Dashboard = lazy(() =>
  import('views/pages/Dashboard/Dashboard').then(module => ({
    default: module.Dashboard,
  })),
);
const LearnersDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/LearnersDrilldown').then(module => ({
    default: module.LearnersDrilldown,
  })),
);
const PositionDetailDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/PositionDetailDrilldown').then(module => ({
    default: module.PositionDetailDrilldown,
  })),
);
const PrioritiesDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/PrioritiesDrilldown').then(module => ({
    default: module.PrioritiesDrilldown,
  })),
);
const ReadinessDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/ReadinessDrilldown').then(module => ({
    default: module.ReadinessDrilldown,
  })),
);
const SkillDetailDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/SkillDetailDrilldown').then(module => ({
    default: module.SkillDetailDrilldown,
  })),
);
const StalledDrilldown = lazy(() =>
  import('views/pages/Dashboard/drilldowns/StalledDrilldown').then(module => ({
    default: module.StalledDrilldown,
  })),
);
const ExpertiseManagement = lazy(() =>
  import('views/pages/ExpertiseManagement/ExpertiseManagement').then(module => ({
    default: module.ExpertiseManagement,
  })),
);
const ExpertiseDetails = lazy(() =>
  import('views/pages/ExpertiseManagement/ExpertiseDetails/ExpertiseDetails').then(
    module => ({ default: module.ExpertiseDetails }),
  ),
);
const ExpertiseFromScratch = lazy(() =>
  import(
    'views/pages/ExpertiseManagement/ExpertiseFromScratch/ExpertiseFromScratch'
  ).then(module => ({ default: module.ExpertiseFromScratch })),
);
const KnowledgeArea = lazy(() =>
  import('views/pages/KnowledgeArea/KnowledgeArea').then(module => ({
    default: module.KnowledgeArea,
  })),
);
const KnowledgeAreaDetails = lazy(() =>
  import('views/pages/KnowledgeArea/KnowledgeAreaDetails/KnowledgeAreaDetails').then(
    module => ({ default: module.KnowledgeAreaDetails }),
  ),
);
const KnowledgeAreaFromScratch = lazy(() =>
  import(
    'views/pages/KnowledgeArea/KnowledgeAreaFromScratch/KnowledgeAreaFromScratch'
  ).then(module => ({ default: module.KnowledgeAreaFromScratch })),
);
const DepartmentManagement = lazy(() =>
  import('views/pages/ManageOrganization/DepartmentManagement/DepartmentManagement').then(
    module => ({ default: module.DepartmentManagement }),
  ),
);
const GeneralInformation = lazy(() =>
  import('views/pages/ManageOrganization/GeneralInformation/GeneralInformation').then(
    module => ({ default: module.GeneralInformation }),
  ),
);
const ManageOrganization = lazy(() =>
  import('views/pages/ManageOrganization/ManageOrganization').then(module => ({
    default: module.ManageOrganization,
  })),
);
const SubscriptionManagement = lazy(() =>
  import(
    'views/pages/ManageOrganization/SubscriptionManagement/SubscriptionManagement'
  ).then(module => ({ default: module.SubscriptionManagement })),
);
const UserManagement = lazy(() =>
  import('views/pages/ManageOrganization/UserManagement/UserManagement').then(module => ({
    default: module.UserManagement,
  })),
);
const GeneralData = lazy(() =>
  import('views/pages/ProfileSettings/GeneralData/GeneralData').then(module => ({
    default: module.GeneralData,
  })),
);
const Welcome = lazy(() =>
  import('views/pages/setup/Welcome/Welcome').then(module => ({
    default: module.Welcome,
  })),
);
const ProfileKnowledgeAreaDetails = lazy(() =>
  import(
    'views/pages/UserProfile/ProfileKnowledgeAreaDetails/ProfileKnowledgeAreaDetails'
  ).then(module => ({ default: module.ProfileKnowledgeAreaDetails })),
);

const publicRoutes = [
  {
    path: PATHS.LOGIN,
    component: Login,
    exact: false,
    title: 'login.title',
  },
  {
    path: PATHS.REGISTRATION,
    component: Registration,
    exact: false,
    title: 'registration.title',
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    component: ForgotPassword,
    exact: false,
    title: 'forgot-password.title',
  },
  {
    path: PATHS.FORGOT_PASSWORD_SENT,
    component: ForgotPasswordSent,
    exact: false,
    title: 'forgot-password.title',
  },
  {
    path: PATHS.RESET_PASSWORD_CHANGED,
    component: ResetPasswordChanged,
    exact: false,
    title: 'reset-password.changed.title',
  },
  {
    path: PATHS.CONFIRMATION,
    component: Confirmation,
    exact: true,
    title: 'confirmation.title',
  },
  {
    path: PATHS.CONFIRMATION_RESULT,
    component: ConfirmationResult,
    exact: false,
    title: 'confirmation-register.title',
  },
  {
    path: PATHS.CONFIRMATION_EXPIRED,
    component: ConfirmationExpired,
    exact: false,
    title: 'confirmation-expired.title',
  },
];

const manageOrganizationRoutes = [
  {
    path: PATHS.MANAGE_ORGANIZATION_USER_MANAGEMENT,
    component: UserManagement,
    exact: true,
    title: 'user-management.nav.title',
    roles: [ROLE_NAME.ADMIN, ROLE_NAME.MENTOR],
  },
  {
    path: PATHS.MANAGE_ORGANIZATION_DEPARTMENT_MANAGEMENT,
    component: DepartmentManagement,
    exact: true,
    title: 'department-management.nav.title',
    roles: [ROLE_NAME.ADMIN, ROLE_NAME.MENTOR],
  },
  {
    path: PATHS.MANAGE_ORGANIZATION_GENERAL_INFORMATION,
    component: GeneralInformation,
    exact: true,
    title: 'general-information.nav.title',
    roles: [ROLE_NAME.ADMIN],
  },
  {
    path: PATHS.MANAGE_ORGANIZATION_SUBSCRIPTION_MANAGEMENT,
    component: SubscriptionManagement,
    exact: true,
    title: 'subscription-management.nav.title',
    roles: [ROLE_NAME.ADMIN],
  },
];

const profileSettingsRoutes = [
  {
    path: PATHS.PROFILE_SETTINGS_GENERAL_DATA,
    component: GeneralData,
    exact: true,
    title: 'general-data-profile.nav.title',
  },
];

const privateRoutes = [
  {
    path: PATHS.MANAGE_ORGANIZATION,
    component: ManageOrganization,
    exact: false,
    title: 'manage-organization.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.ROOT,
    component: Welcome,
    exact: true,
    title: 'welcome.nav.title',
    isBlockedRoute: false,
  },
  {
    path: `${PATHS.USER_PROFILE}/:userId/${PATHS.USER_PROFILE_KNOWLEDGE_AREA_DETAILS}/:id`,
    component: ProfileKnowledgeAreaDetails,
    exact: true,
    title: 'user-profile.knowledge-area-details.nav.title',
  },
  {
    path: PATHS.COMPANY_MEMBERS,
    component: CompanyMembers,
    exact: true,
    title: 'navigation.company-members',
    isBlockedRoute: false,
  },
  {
    path: PATHS.EXPERTISE_MANAGEMENT,
    component: ExpertiseManagement,
    exact: true,
    title: 'navigation.expertise-management',
    isBlockedRoute: true,
  },
  {
    path: `${PATHS.EXPERTISE_MANAGEMENT}/:id`,
    component: ExpertiseDetails,
    exact: true,
    title: 'expertise-details.page-title',
  },
  {
    path: PATHS.EXPERTISE_MANAGEMENT_FROM_SCRATCH,
    component: ExpertiseFromScratch,
    exact: true,
    title: 'navigation.expertise-management',
    isBlockedRoute: false,
  },
  {
    path: PATHS.KNOWLEDGE_AREA,
    component: KnowledgeArea,
    exact: true,
    title: 'navigation.knowledge-area-management',
    isBlockedRoute: true,
  },
  {
    path: `${PATHS.KNOWLEDGE_AREA}/:id`,
    component: KnowledgeAreaDetails,
    exact: true,
    title: 'knowledge-area.details.title',
    isBlockedRoute: false,
  },
  {
    path: PATHS.KNOWLEDGE_AREA_FROM_SCRATCH,
    component: KnowledgeAreaFromScratch,
    exact: true,
    title: 'knowledge-area.from-scratch.title',
    isBlockedRoute: false,
  },
  {
    path: PATHS.DASHBOARD_READINESS_SKILL,
    component: SkillDetailDrilldown,
    exact: true,
    title: 'dashboard.readiness.skill.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_READINESS_DETAIL,
    component: PositionDetailDrilldown,
    exact: true,
    title: 'dashboard.readiness.detail.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_READINESS,
    component: ReadinessDrilldown,
    exact: true,
    title: 'dashboard.readiness.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_LEARNERS,
    component: LearnersDrilldown,
    exact: true,
    title: 'dashboard.learners.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_STALLED,
    component: StalledDrilldown,
    exact: true,
    title: 'dashboard.stalled.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_PRIORITIES,
    component: PrioritiesDrilldown,
    exact: true,
    title: 'dashboard.priorities.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD_ACTIVITY,
    component: ActivityDrilldown,
    exact: true,
    title: 'dashboard.activity.title',
    isBlockedRoute: true,
  },
  {
    path: PATHS.DASHBOARD,
    component: Dashboard,
    exact: true,
    title: 'dashboard.title',
    isBlockedRoute: true,
  },
];

export { publicRoutes, manageOrganizationRoutes, privateRoutes, profileSettingsRoutes };
